import { KYC_SCENARIOS, KYCScenario } from "./kyc-scenarios/index.ts";

// KYC states the mock can be forced into via `x-mock-scenario` (the onboarding frame's
// `forceError` param). The fixed states are stateless fixtures; the scripted ones come
// from the kyc-scenarios registry.
export const FORCED_KYC_SCENARIOS = [
  { value: "collecting", label: "KYC collecting" },
  { value: "verifying", label: "KYC verifying" },
  { value: "approved", label: "KYC approved (active)" },
  { value: "rejected", label: "KYC rejected (unavailable)" },
  { value: "challengeRequired", label: "KYC challenge required" },
  { value: "address_confirmation_required", label: "Address needs confirmation" },
  ...Object.values(KYCScenario).map((value) => ({ value, label: KYC_SCENARIOS[value].label })),
] as const;

export type ForcedKycScenario = (typeof FORCED_KYC_SCENARIOS)[number]["value"];
